export const DEFAULT_PAGE_SIZE = 24;

export const OPERATIONS_TABLE_COLUMNS = '2fr 1.5fr 1fr 1.25fr 1fr 14px';
